export default __webpack_public_path__ + "static/media/ParallelImg.11e95c07.jpg";